export const LogoWithoutTextIcon = ({ size = 1 }) => {
  return (
    <svg
      width={33 * size}
      height={26 * size}
      viewBox="0 0 33 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.297 17.1562L10.8689 25.6369H21.7243L16.297 17.1562Z"
        fill="#26BE50"
      />
      <path
        d="M5.43188 8.65948H16.296L10.8635 0.171875L5.43188 8.65948Z"
        fill="#198C39"
      />
      <path
        d="M10.8591 17.1373L10.8635 17.1434L16.296 8.65625H5.43188L10.8591 17.1373Z"
        fill="#1DA843"
      />
      <path
        d="M21.7275 0.171875L16.2959 8.65948H27.16L21.7275 0.171875Z"
        fill="#198C39"
      />
      <path
        d="M16.2959 8.65625L21.7275 17.1434L27.16 8.65625H16.2959Z"
        fill="#1DA843"
      />
      <path
        d="M5.43203 8.65625L0.00390625 17.1373H10.8593L5.43203 8.65625Z"
        fill="#26BE50"
      />
      <path
        d="M0.00392134 17.1406L0 17.1467L5.43205 25.6347L10.8637 17.1467L10.8593 17.1406H0.00392134Z"
        fill="#28D658"
      />
      <path
        d="M10.8589 17.1406L10.863 17.1463L10.8589 17.1406Z"
        fill="url(#paint0_radial_2598_18349)"
      />
      <path
        d="M10.8589 17.1406L10.863 17.1463L10.8589 17.1406Z"
        fill="url(#paint1_radial_2598_18349)"
      />
      <path
        d="M21.7247 0.164062H10.8693L10.865 0.171028L16.2975 8.65863L21.7291 0.171028L21.7247 0.164062Z"
        fill="#43BA65"
      />
      <path
        d="M32.5871 17.1406H21.733L21.7278 17.1467L27.1603 25.6347L32.5919 17.1467L32.5871 17.1406Z"
        fill="#28D658"
      />
      <path
        d="M32.587 17.1373L27.1602 8.65625L21.7329 17.1373H32.587Z"
        fill="#26BE50"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2598_18349"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.60751 -1.99765) scale(18.4942 18.4459)"
        >
          <stop stopColor="#FFC113" />
          <stop offset="1" stopColor="#E75825" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_2598_18349"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.9851 8.15446) scale(14.074 14.0372)"
        >
          <stop stopColor="#FFC113" />
          <stop offset="1" stopColor="#E75825" />
        </radialGradient>
      </defs>
    </svg>
  );
};
